module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Book.522bce29.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/frutiger/FrutigerNeueLTW04-Book.woff
// module id = 638
// module chunks = 0